import { useLocation } from 'react-router';
import { useAppContext } from '../../appProvider/contextProvider';
import Routes from '../../routes/routes';
import Loader from '../Loader/loader';
import CancelPlan from '../PaymentPrompts/CancelPlan';
import ChangePlan from '../PaymentPrompts/ChangePlan';
import ConfirmPlan from '../PaymentPrompts/ConfirmPlan';
import PaymentFailed from '../PaymentPrompts/PaymentFailed';
import PaymentSuccess from '../PaymentPrompts/PaymentSuccess';
import PricingPlans from '../PaymentPrompts/PricingPlans';
import DiscardPrompt from '../Propmts/discardPrompt';
import WebsiteDropDown from '../WebsiteDropdown/WebsiteDropDown';

const WrapperContainer = ({ onCancelDiscard,
    onDiscard,   
}) => {

    const { isFetching, 
        isMutating, 
        isDiscardPromptOpen, 
        isPricingPopupOpen, 
        isBgDisabled,
        isChangePlanPopupOpen,
        isCancelPlanPopupOpen,
        isVerifyPopupOpen,
        isPaymentSuccess,
        isCardSuccess,
        isPaymentFailure, 
        isCardFailure, 
        isUpdatePlanSuccess,
        isUpdatePlanFailure,
        isCancelPlanSuccess,
        isCancelPlanFailure,
        // userDetails,
        // chatVisibility,
        isLoading
    } = useAppContext();

    let containerClasses = ['page-container', 'full-height', 'overflow-hidden'];

    const location = useLocation();

    if(location.pathname === '/dashboard') {
        containerClasses.push('p-0');
        if(!!(isMutating || isFetching || isDiscardPromptOpen || isBgDisabled)) {
            containerClasses.push('loader');
            containerClasses.push('mb-2');
        } else {
            containerClasses.push('pb-2');
        }
    } else {
        containerClasses = ['page-container', 'full-height', 'overflow-hidden'];
        if(!!(isMutating || isFetching || isDiscardPromptOpen || isBgDisabled)) {
            containerClasses.push('loader');
        }
    }

    // const onVisibilityChanged = (event) => {
    // }
    
    return <>
        <div className={containerClasses.join(' ')} >
            <div className={location.pathname === '/dashboard' ? 'd-flex justify-content-center mt-3' : 'd-flex justify-content-center'}>
                <WebsiteDropDown />
            </div>
            {
                /* Loader */
                !!(isMutating || isFetching || isLoading) && <Loader /> 
            }
            {
                /* Discard Prompt */
                isDiscardPromptOpen && <DiscardPrompt onDiscard={onDiscard} onCancel={onCancelDiscard} />
            }
            {
                isPricingPopupOpen && <PricingPlans />
            }
            {
                isChangePlanPopupOpen && <ChangePlan />
            }
            {
                isCancelPlanPopupOpen && <CancelPlan />
            }
            {
                isVerifyPopupOpen && <ConfirmPlan />
            }
            {
                (isPaymentSuccess || isCardSuccess 
                || isUpdatePlanSuccess || isCancelPlanSuccess) && <PaymentSuccess />
            }
            {
                (isPaymentFailure ||  isCardFailure 
                || isUpdatePlanFailure || isCancelPlanFailure) && <PaymentFailed />            
            }

    
            <Routes  />

        </div>
    </>
}


export default WrapperContainer;
